<template>
  <div id="hress5u">
    <hrms-search-box-table v-show="indexDisp"
            :data="index"
            :nowLang="dash.nowLang"
            :columns="columns[dash.nowLang].index"
            :receivedStore="receivedHress5uIndex"
            searchBoxAlias="approve"
            :detailEvent="detailEvent"
            :approveEvent="postHress5uSendApprove" />
            
    <detail v-show="detailDisp"
            :labelsButton="dash.button[dash.nowLang]"
            :labels="labels[dash.nowLang]"
            :detail="detail"
            :tab2Table="columns[dash.nowLang].detailTab2"
            :columnsDetailTab2Popup2Tab2="columns[dash.nowLang].detailTab2Popup2Tab2"
            :columnsDetailTab2Popup2Tab3="columns[dash.nowLang].detailTab2Popup2Tab3"
            :columnsDetailTab2Popup2Tab4="columns[dash.nowLang].detailTab2Popup2Tab4"
            :toggle="toggle"
            :nowLang="dash.nowLang"
            :popup1DetailTab2="popup1DetailTab2"
            :popup2DetailTab2="popup2DetailTab2"
            :receivedHress5uDetailTab2Popup1="receivedHress5uDetailTab2Popup1"
            :receivedHress5uDetailTab2Popup2="receivedHress5uDetailTab2Popup2" />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as types from 'store/modules/hress5u/mutation-types'
import detail from 'components/hress5u/detail'
import moment from 'moment'

export default {
  name: 'hress5u',
  data () {
    return {
      dash: this.$parent.$parent.$parent,
      dtereq: moment().format('DD/MM/YYYY')
    }
  },
  created () {
    this.receivedHress5uColumnsLabels()
    this.receivedHress5uIndex()
  },
  computed: {
    codempid () {
      let currentUser = this.dash.currentUser
      return currentUser.p_codempid
    },
    ...mapGetters({
      indexDisp: types.GET_HRESS5U_INDEX_DISP,
      detailDisp: types.GET_HRESS5U_DETAIL_DISP,
      columns: types.GET_HRESS5U_COLUMNS,
      labels: types.GET_HRESS5U_LABELS,
      index: types.GET_HRESS5U_INDEX,
      indexSelected: types.GET_HRESS5U_INDEX_SELECTED,
      detail: types.GET_HRESS5U_DETAIL,
      popup1DetailTab2: types.GET_HRESS5U_DETAIL_TAB2_POPUP1,
      popup2DetailTab2: types.GET_HRESS5U_DETAIL_TAB2_POPUP2
    })
  },
  methods: {
    pageDetail (event) {
      let searchParams = {
        p_codempid: this.indexSelected.codempid,
        p_dtereq: this.indexSelected.dtereq,
        p_numseq: this.indexSelected.numseq
      }
      this.receivedHress5uDetail(searchParams)
      this.toggle('detail')
    },
    detailEvent (param) {
      this.setIndexSelected(param)
      this.pageDetail()
    },
    ...mapMutations({
      setIndexSelected: types.SET_HRESS5U_INDEX_SELECTED
    }),
    ...mapActions({
      toggle: types.TOGGLE_HRESS5U_PAGE,
      receivedHress5uColumnsLabels: types.RECEIVED_HRESS5U_COLUMNS_LABELS,
      receivedHress5uIndex: types.RECEIVED_HRESS5U_INDEX,
      receivedHress5uDetail: types.RECEIVED_HRESS5U_DETAIL,
      receivedHress5uDetailTab2Popup1: types.RECEIVED_HRESS5U_DETAIL_TAB2_POPUP1,
      receivedHress5uDetailTab2Popup2: types.RECEIVED_HRESS5U_DETAIL_TAB2_POPUP2,
      postHress5uSendApprove: types.POST_HRESS5U_SEND_APPROVE
    })
  },
  components: {
    detail
  }
}
</script>




// WEBPACK FOOTER //
// component.vue?f7d878ea